import { render, staticRenderFns } from "./ShopChain.vue?vue&type=template&id=09708501&"
import script from "./ShopChain.vue?vue&type=script&lang=js&"
export * from "./ShopChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports